$(function() {
  
	/*
	* BACK TO TOP
	*/
	$('.js-back-to-top').click(function(){
		$('html, body').animate({scrollTop : 0},800);
        $(this).closest('.scroll').animate({

            scrollTop: 0

        }, 800);
		return false;
	});

});
